import { createHooks } from 'hookable'
import type HookErrorResponse from '#src/types/HookErrorResponse'

const AcceptorsHooksManager = createHooks<{
  BeforeAcceptorsStart: (params: { errorResponses: Array<HookErrorResponse> }) => void
}>()

export default AcceptorsHooksManager
